module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="'+
((__t=( content.id ))==null?'':__t)+
'" class="drawer drawer-modal" role="dialog">\n    <button class="drawer-close as-overlay" type="button"><span class="visually-hidden">{{ \'general.accessibility.close_modal\' | t }}</span></button>\n    <div class="drawer-content">\n        <button class="drawer-close" type="button"><span class="visually-hidden">{{ \'general.accessibility.close_modal\' | t }}</span></button>\n        '+
((__t=( content.body ))==null?'':__t)+
'\n    </div>\n</div>';
}
return __p;
};
